// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 3H23V21H1V3ZM5 11V13H11V11H5ZM5 15V17H19V15H5ZM16.502 8.6875L19 10.75L19 5L14.0039 5V10.75L16.502 8.6875Z"}}]};

const CertificateFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'certificate-filled',
    ref,
    icon: element,
  },
));

CertificateFilledIcon.displayName = 'CertificateFilledIcon';

export default CertificateFilledIcon;
